import request from './request';

// info
export const getGoogleTemplatesInfo = ({ id }: { id: string }) => {
  return request({
    url: '/carbon-promotion/public/google/template/detail',
    method: 'get',
    params: { id }
  });
};
